import axios from 'axios';

import { TransferJob, TransferProvider, TransferStatusMappingEntry } from '../../entities/transfer';
import { auth } from '../firebase/firebase';
import { API_BASE_URL } from './index';

const getHeaders = async () => {
  const idToken = await auth.currentUser?.getIdToken();
  return { Authorization: `Bearer ${idToken}` };
};

export const createTransferJob = async (input: {
  sourceProvider: TransferProvider;
  targetProvider: TransferProvider;
  sourceProjectId: string;
  targetProjectName?: string;
}): Promise<TransferJob> => {
  const headers = await getHeaders();
  const { data } = await axios.post<TransferJob>(`${API_BASE_URL}/api/transfer/jobs`, input, { headers });
  return data;
};

export const listTransferJobs = async (): Promise<TransferJob[]> => {
  const headers = await getHeaders();
  const { data } = await axios.get<{ jobs: TransferJob[] }>(`${API_BASE_URL}/api/transfer/jobs`, { headers });
  return data.jobs;
};

export const getTransferJob = async (jobId: string): Promise<TransferJob> => {
  const headers = await getHeaders();
  const { data } = await axios.get<TransferJob>(`${API_BASE_URL}/api/transfer/jobs/${jobId}`, { headers });
  return data;
};

export const updateTransferMapping = async (
  jobId: string,
  mapping: TransferStatusMappingEntry[],
): Promise<TransferJob> => {
  const headers = await getHeaders();
  const { data } = await axios.patch<TransferJob>(
    `${API_BASE_URL}/api/transfer/jobs/${jobId}/mapping`,
    { mapping },
    { headers },
  );
  return data;
};

export const confirmTransferJob = async (jobId: string): Promise<TransferJob> => {
  const headers = await getHeaders();
  const { data } = await axios.post<TransferJob>(
    `${API_BASE_URL}/api/transfer/jobs/${jobId}/confirm`,
    {},
    {
      headers,
    },
  );
  return data;
};

export const retryTransferJob = async (jobId: string): Promise<TransferJob> => {
  const headers = await getHeaders();
  const { data } = await axios.post<TransferJob>(
    `${API_BASE_URL}/api/transfer/jobs/${jobId}/retry`,
    {},
    {
      headers,
    },
  );
  return data;
};
